module.exports = __webpack_public_path__ + "static/media/image5.6238c067.png";